import jwt_decode from 'jwt-decode';

import { ITokenDecoded, ITokenPayload } from 'interfaces/User';
import { store } from 'store';
import { openAlert } from 'modules/alertHandler';
import { userLogoutAction } from 'modules/user';
import { DispatchAction } from 'interfaces/utils';
import { AnyAction } from '@reduxjs/toolkit';
import { GridFeatureMode } from '@material-ui/data-grid';

export const capitalizeString = (string: string): string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const decodeToken = (token: string): ITokenDecoded & ITokenPayload => {
  const decoded = jwt_decode<ITokenPayload>(token);
  return Object.assign<ITokenDecoded, ITokenPayload>({ token }, decoded);
};

export const parseActionForDispacth = (action: DispatchAction): AnyAction =>
  typeof action === 'object'
    ? Object.assign({ $uuid: '', $wuid: '', ...action })
    : action;

export const showLogoutAlert = (): void => {
  store.dispatch(
    openAlert({
      title: 'Sua Sessão Expirou',
      content: 'Favor Logar Novamente',
      primaryButton: 'Ok',
      primaryButtonAction: userLogoutAction(),
    }),
  );
};

export const gridColumnHeaderWithoutAction = {
  filterable: false,
  sortable: false,
  disableColumnMenu: true,
};

export const gridClientMode = {
  filterMode: 'client' as GridFeatureMode,
  paginationMode: 'client' as GridFeatureMode,
  sortingMode: 'client' as GridFeatureMode,
};
